import { IMessage } from './message';
import { IAppContext } from './type';

interface IApp {
  processHandler?: any;
}

export default class PluginProcessor<T extends IMessage> {
  private app: IApp;
  private ctx: IAppContext<T>;

  constructor(app: IApp, ctx: IAppContext<T>) {
    this.app = app;
    this.ctx = ctx;
  }

  /**
   * @description 注册插件
   * @param plugins
   */
  public registerPlugins(plugins?: any) {
    if (plugins && plugins.length) {
      plugins.forEach(this.handlePlugin);
    }
  }

  private handlePlugin = (plugin: any) => {
    // 初始化
    plugin.apply(this.app, this.ctx);

    // 加载
    this.app.processHandler(plugin);
  };
}
